<div class="dialog-box">
  <a *ngIf="!closeDisabled" class="close-icon" [matDialogClose]="false"
    >&times;</a
  >

  <div class="dialog-contents-box">
    <h4 class="dialog-title">{{ title }}</h4>

    <article class="dialog-content" [innerHTML]="message"></article>
  </div>

  <div class="dialog-buttons-box">
    <button
      class="dialog-button"
      [class.hide]="!cancelButtonText"
      (click)="close(false)"
    >
      {{ cancelButtonText }}
    </button>

    <button
      class="dialog-button"
      [class.hide]="!confirmButtonText"
      (click)="close(true)"
    >
      {{ confirmButtonText }}
    </button>
  </div>
</div>
